import { DynamicText } from '@/components/dynamic-text';

export default function AboutPage() {
  return (
    <div className="container py-16 sm:py-24">
      <header className="max-w-[62ch]">
        <p className="kicker">
          <DynamicText path="about.kicker">About</DynamicText>
        </p>
        <h1 className="mt-4 text-[clamp(2.4rem,6vw,3.8rem)] leading-[1.02]">
          <DynamicText path="about.title">Why we built Bramble</DynamicText>
        </h1>
      </header>

      <div className="hairline my-12" />

      <div className="max-w-2xl space-y-6 text-lg leading-relaxed text-foreground/80">
        <p>
          <DynamicText path="about.p1">
            We created Bramble because basic baby tracking should not disappear behind a subscription.
            Every on-device tracking feature is free. The optional $4.99/month Bramble Sharing plan
            pays for co-parent sync and babysitting access without ads, data sales, or murky privacy
            promises.
          </DynamicText>
        </p>
        <p>
          <DynamicText path="about.p2">
            Finally, because it's important to be transparent: Bramble was created in large part with the help of AI coding agents. There are lots of downsides to the advent of AI in our lives, and some of the use cases being proposed by big tech are laughable at best and existentially threatening at worst. But building specialized software more efficiently is one use case we can stand behind, especially when it helps keep the complete on-device tracker free and the optional service straightforwardly priced.
          </DynamicText>
        </p>
      </div>
    </div>
  );
}
